import { put } from "../util/http.service";

export const apiUpdateSitesStatuses = id => ({
  mutationFn: data => put("/api/parameters/sites-statuses", data)
});

export const apiUpdateWorkers = id => ({
  mutationFn: data => put("/api/parameters/workers", data)
});
